// AWS API Gateway endpoint
export const BASE_URL = "https://cxupy5djqa.execute-api.ap-south-1.amazonaws.com/dev/api/v1";

// AWS API Gateway WebSocket endpoint (set after deploying the WebSocket stack)
// Replace <WS_API_ID> with the actual WebSocket API ID from the SAM deploy output
export const WS_URL = process.env.REACT_APP_WS_URL || "wss://z9z650g5dg.execute-api.ap-south-1.amazonaws.com/dev";

// Legacy endpoints (commented out)
// export const BASE_URL = "https://api.vivahbandh.com/";
// export const BASE_URL = "http://[::1]:3001";
// export const BASE_URL = "http://vivahbandh-api-env-1.eba-hescmnrc.ap-south-1.elasticbeanstalk.com/";